export default "__VITE_ASSET__DZfbs10$__"